import React, { useState } from 'react';
import SignIn from '../../containers/SignInContainer';
import SignUp from '../../containers/SignUpContainer';
import ForgotPassword from '../../containers/ForgotPasswordContainer';
/**
 * Renders all login component with default from config
 *
 * @param  {string} [className] - the CSS classes
 * @param  {(response: unknown) => void} [onSuccess] - onSuccess call function
 * @param  {string} [inputStyles] - input CSS classes
 * @param  {string} [buttonStyles] - btn CSS classes
 * @param  {string} [labelStyles] - label CSS classes
 * @param  {string} [linkStyles] - link CSS classes
 * @param  {string} [formStyles] - form CSS classes
 * @param  {string} [formGroupStyles] - form group CSS classes
 *
 * @example
 * <AuthComponent
 *  className='a6y-react-auth'
 *  onSuccess={(response: unknown) => void}
 * />
 */
var AuthComponent = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? 'a6y-react-auth' : _c, onSuccess = _a.onSuccess, _d = _a.inputStyles, inputStyles = _d === void 0 ? '' : _d, _e = _a.buttonStyles, buttonStyles = _e === void 0 ? '' : _e, _f = _a.labelStyles, labelStyles = _f === void 0 ? '' : _f, _g = _a.linkStyles, linkStyles = _g === void 0 ? '' : _g, _h = _a.formStyles, formStyles = _h === void 0 ? '' : _h, _j = _a.formGroupStyles, formGroupStyles = _j === void 0 ? '' : _j;
    var classNames = require('classnames');
    var _k = useState('sign-in'), currentForm = _k[0], setCurrentForm = _k[1];
    var mainClass = classNames((_b = {},
        _b["a6y-react-auth__" + currentForm] = className === 'a6y-react-auth' ? true : false,
        _b));
    var getAuthForm = function () {
        switch (currentForm) {
            case 'sign-up':
                return (React.createElement(SignUp, { onSuccess: onSuccess ? onSuccess : undefined, onLinkHandler: function (to) { return setCurrentForm(to); }, inputStyles: inputStyles, labelStyles: labelStyles, buttonStyles: buttonStyles, linkStyles: linkStyles, formStyles: formStyles, formGroupStyles: formGroupStyles }));
            case 'forgot-password':
                return (React.createElement(ForgotPassword, { onSuccess: onSuccess ? onSuccess : undefined, onLinkHandler: function (to) { return setCurrentForm(to); }, inputStyles: inputStyles, labelStyles: labelStyles, buttonStyles: buttonStyles, linkStyles: linkStyles, formStyles: formStyles, formGroupStyles: formGroupStyles }));
            default:
                return (React.createElement(SignIn, { onSuccess: onSuccess ? onSuccess : undefined, onLinkHandler: function (to) { return setCurrentForm(to); }, inputStyles: inputStyles, labelStyles: labelStyles, buttonStyles: buttonStyles, linkStyles: linkStyles, formStyles: formStyles, formGroupStyles: formGroupStyles }));
        }
    };
    return React.createElement("div", { className: className + ' ' + mainClass }, getAuthForm());
};
export default AuthComponent;
//# sourceMappingURL=AuthComponent.js.map